// extracted by mini-css-extract-plugin
module.exports = {"defaultImage":"Qt9dcH"};